export default __webpack_public_path__ + "static/media/hero-bg.e6da1292.png";